import instance from "api";
import axios from "api";
import { ApiReturn } from "components/ForgottenPassword/forgottenPasswordApi";
import { endpoints } from "config";
import { add } from "date-fns";
import { CalendarDetails, ParsedCalendarDetails } from "./models";

type getMeetingSummariesPayload = {
  DateFrom: string;
  DateTo: string;
  TimeZone: string;
};

export const getMeetingSummaries = async (
  params: getMeetingSummariesPayload
): Promise<ApiReturn> => {
  try {
    const res = await axios.get(endpoints.bookingModule.eventsSummaryUrl, {
      params,
    });
    console.log(res);
    if (res.data.status === "1") {
      return {
        response: res.data.details,
        errors: null,
      };
    } else {
      return {
        response: null,
        errors: res.data.errors,
      };
    }
  } catch (error) {
    if (error.response) {
      // Request made and server responded
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return error.request;
      console.log(error.request);
    } else {
      return error.message;
      // Something happened in setting up the request that triggered an Error
    }
  }
};

export const createAvailability = async (params: any): Promise<ApiReturn> => {
  try {
    const res = await axios.post(
      endpoints.bookingModule.createAvailability,
      params
    );
    console.log(res);
    if (res.data.status === "1") {
      return {
        response: res.data.details,
        errors: null,
      };
    } else {
      return {
        response: null,
        errors: res.data.errors,
      };
    }
  } catch (error) {
    if (error.response) {
      // Request made and server responded
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return error.request;
      console.log(error.request);
    } else {
      return error.message;
      // Something happened in setting up the request that triggered an Error
    }
  }
};

export const cancelCalendarMeeting = async (
  params: any
): Promise<ApiReturn> => {
  try {
    const res = await axios.post(
      endpoints.bookingModule.cancelMeetingUrl,
      params
    );
    console.log(res);
    if (res.data.status === "1") {
      return {
        response: true,
        errors: null,
      };
    } else {
      return {
        response: null,
        errors: res.data.errors,
      };
    }
  } catch (error) {
    if (error.response) {
      // Request made and server responded
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return error.request;
      console.log(error.request);
    } else {
      return error.message;
      // Something happened in setting up the request that triggered an Error
    }
  }
};

export const getUpdatedAvailabilities = async (): Promise<ApiReturn> => {
  const dateFrom = new Date();
  const dateTo = add(new Date(), { years: 5 });

  const config = {
    params: {
      dateFrom,
      dateTo,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  };

  try {
    const res = await axios.get(
      endpoints.bookingModule.getAvailability,
      config
    );
    console.log(res);
    if (res.data.status === "1") {
      return {
        response: res.data.details,
        errors: null,
      };
    } else {
      return {
        response: null,
        errors: res.data.errors,
      };
    }
  } catch (error) {
    if (error.response) {
      // Request made and server responded
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return error.request;
      console.log(error.request);
    } else {
      return error.message;
      // Something happened in setting up the request that triggered an Error
    }
  }
};

export const getUpdatedMeetings = async (): Promise<ApiReturn> => {
  const dateFrom = new Date();
  const dateTo = add(new Date(), { years: 5 });

  const config = {
    params: {
      dateFrom,
      dateTo,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  };

  try {
    const res = await axios.get(
      endpoints.bookingModule.eventsSummaryUrl,
      config
    );
    if (res.data.status === "1") {
      return {
        response: res.data.details,
        errors: null,
      };
    } else {
      return {
        response: null,
        errors: res.data.errors,
      };
    }
  } catch (error) {
    if (error.response) {
      // Request made and server responded
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return error.request;
      console.log(error.request);
    } else {
      return error.message;
      // Something happened in setting up the request that triggered an Error
    }
  }
};

export const getCalendarDetails = async (accessToken: string) => {
  instance.interceptors.request.use(config => {
    config.headers["MicrosoftGraphAuthorization"] = accessToken;
    return config;
  });
  const result = await instance.get(
    "/api/calendarmodule/microsoftgraph/get-calendar-details"
  );
  if (result.data.details) {
    return {
      response: result.data.details,
      errors: null,
    };
  } else {
    return {
      response: null,
      errors: result.data.errors,
    };
  }
};

export const parseGetCalendarDetails = (
  results: CalendarDetails[]
): ParsedCalendarDetails[] => {
  return results
    .filter(({ canEdit }) => canEdit)
    .map(({ id, name, isDefaultCalendar }) => ({
      label: name,
      value: { id, isDefaultCalendar, name },
    }));
};

export const syncCalendarDetails = async (accessToken: string, params: any) => {
  instance.interceptors.request.use(config => {
    config.headers["MicrosoftGraphAuthorization"] = accessToken;
    return config;
  });
  const result = await instance.post(
    "/api/calendarmodule/microsoftgraph/sync-with-outlook",
    params
  );
  if (result.data.details === "1") {
    return {
      response: true,
      errors: null,
    };
  } else {
    return {
      response: null,
      errors: true,
    };
  }
};

export const ongoingSyncCalendarDetails = async (accessToken: string) => {
  instance.interceptors.request.use(config => {
    config.headers["MicrosoftGraphAuthorization"] = accessToken;
    return config;
  });
  const result = await instance.post(
    "/api/calendarmodule/microsoftgraph/ongoing-sync"
  );
  if (result.data.status === "1") {
    return {
      response: true,
      errors: null,
    };
  } else {
    return {
      response: null,
      errors: true,
    };
  }
};
